module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-segment-js/gatsby-browser.js'),
      options: {"plugins":[],"prodKey":"yShZvFJ9ts3nfC9oz6nbDN0Nuv84YE1J","trackPage":true,"delayLoad":true,"delayLoadTime":1000},
    }]
